import React from 'react';
import { motion } from 'framer-motion';
import { LogoIcon } from './logo/LogoIcon';
import { LogoRocket } from './logo/LogoRocket';
import {
  LOGO_HOVER_ANIMATION, LOGO_TRANSITION, GLOW_ANIMATION, GLOW_TRANSITION,
  TEXT_INITIAL, TEXT_ANIMATE, TEXT_TRANSITION,
} from './logo/logoMotion';

const AnimatedLogo = () => (
  <motion.div
    className="flex items-center gap-2.5 cursor-pointer group relative"
    whileHover={LOGO_HOVER_ANIMATION}
    transition={LOGO_TRANSITION}
  >
    <div className="relative w-16 h-16">
      <motion.div
        className="absolute inset-0 rounded-xl bg-gradient-to-br from-orange-500/40 via-blue-500/40 to-purple-500/40 blur-lg"
        animate={GLOW_ANIMATION}
        transition={GLOW_TRANSITION}
      />
      <LogoIcon />
      <LogoRocket />
    </div>
    <motion.span
      className="text-2xl font-light text-white tracking-wide"
      initial={TEXT_INITIAL}
      animate={TEXT_ANIMATE}
      transition={TEXT_TRANSITION}
    >
      DIGITAL
    </motion.span>
  </motion.div>
);

export default AnimatedLogo;
